import {Validator} from '@/type/validation/result';
import {半角カナ禁止, 全角のみ, 半角のみ} from '@/type/validation/validator';

function 未入力または三文字以上の入力が必要(value: string) {
  if (!value) {
    return true;
  }
  return (value.length >= 3);
}

function 入力は10文字以内(value: string) {
  if (!value) {
    return true;
  }
  return (value.length <= 10);
}

export const 棚番設定バリデータ一覧: Validator[] = [
  {
    name: '棚名',
    constraints: [
      {method: 全角のみ, message: '棚名には全角のみ設定可能です'},
      {method: 入力は10文字以内, message: '棚名には10文字まで設定可能です'},
    ],
  },
  {
    name: '棚番',
    constraints: [
      {method: 半角のみ, message: '棚番号は半角のみ使用可能です'},
      {method: 入力は10文字以内, message: '棚番号には10文字まで設定可能です'},
    ],
  },
];

export const 表示条件バリデータ一覧: Validator[] = [
  {
    name: '棚名',
    constraints: [
      {method: 全角のみ, message: '棚名は全角のみ使用可能です'},
      {method: 入力は10文字以内, message: '棚名は10文字まで入力可能です'},
    ],
  },
  {
    name: '棚番',
    constraints: [
      {method: 半角のみ, message: '棚番号は半角のみ使用可能です'},
      {method: 入力は10文字以内, message: '棚番号は10文字まで入力可能です'},
    ],
  },
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
      {method: 未入力または三文字以上の入力が必要, message: '商品名カナは３文字以上の入力が必要です'},
    ],
  },
];

export const 全指定棚番設定バリデータ一覧: Validator[] = [
  {
    name: '棚名',
    constraints: [
      {method: 全角のみ, message: '棚名には全角のみ設定可能です'},
      {method: 入力は10文字以内, message: '棚名には10文字まで設定可能です'},
    ],
  },
  {
    name: '棚番',
    constraints: [
      {method: 半角のみ, message: '棚番号は半角のみ使用可能です'},
      {method: 入力は10文字以内, message: '棚番号には10文字まで設定可能です'},
    ],
  },
];

